import base from "./base";

const config = { ...base };
config.basePath = process.env.REACT_APP_BASE_PATH || "";
config.spaces.previewURL = process.env.REACT_APP_SPACE_PREVIEWER_URL!;
config.hubspot.appID = process.env.REACT_APP_HUBSPOT_APP_ID!;
config.google.analyticsTrackerID =
  process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKER_ID!;
config.google.tagManagerAccountID =
  process.env.REACT_APP_GOOGLE_TAG_MANAGER_ACCOUNT_ID!;
config.google.apiKey = process.env.REACT_APP_GOOGLE_API_KEY!;
config.api.url = process.env.REACT_APP_API_URL!;
config.google.signInClientID = process.env.REACT_APP_GOOGLE_SIGN_IN_CLIENT_ID!;
config.stripe.apiKey = process.env.REACT_APP_STRIPE_API_KEY!;
config.sentry.url = process.env.REACT_APP_SENTRY_URL!;
config.canva.apiKey = process.env.REACT_APP_CANVA_API_KEY!;
config.youTube.apiKey = process.env.REACT_APP_YOUTUBE_API_KEY!;
export default config;
